import { fetcher } from "helpers/fetcher";

import {
  TGetDetailBusinessEstablishmentReq,
  TGetDetailBusinessEstablishmentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getDetailBusinessEstablishment = async (
  params?: TGetDetailBusinessEstablishmentReq
) => {
  return await fetcher<
    TGetDetailBusinessEstablishmentRes,
    TGetDetailBusinessEstablishmentReq
  >(ENDPOINT.CORPORATION.GET_DETAIL_BUSINESS_ESTABLISHMENT, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_DETAIL_BUSINESS_ESTABLISHMENT.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
      [API_HEADER.BLOCK_404]: true,
    },
  });
};

export const queryGetDetailBusinessEstablishment = async (
  params?: TGetDetailBusinessEstablishmentReq
) => {
  return (await getDetailBusinessEstablishment(params)).data;
};

queryGetDetailBusinessEstablishment._key = (
  params?: TGetDetailBusinessEstablishmentReq
) => [ENDPOINT.CORPORATION.GET_DETAIL_BUSINESS_ESTABLISHMENT.url, params];
